import { apiRequestPostWithRetry } from "../utils/apiRequest";

export const adminPayReferrals = async (referralIds: string[]) => {
  const response = await apiRequestPostWithRetry<{ data: unknown }>({
    path: "/admin/referrals/complete",
    body: {
      referralIds,
    },
  });

  return response.data;
};
